<script>
export default {
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  props: {
    isOnExpandedLayout: {
      type: Boolean,
      required: true,
    }
  },
  emits: ['toggleConversationLayout', 'openSearch'],
};
</script>

<template>
  <div class="relative">
    <button
      type="button"
      class="flex items-center w-full h-10 px-4 py-2 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border border-slate-200/50 dark:border-slate-600/30 rounded-lg hover:bg-white dark:hover:bg-slate-800 transition-all duration-200"
      @click="$emit('openSearch')"
    >
      <!-- Mobile: Text first, then Icon -->
      <span class="text-sm text-slate-500 dark:text-slate-400 xl:hidden">
        {{ $t('CHAT_LIST.SEARCH.INPUT') }}
      </span>
      <svg 
        class="w-4 h-4 text-slate-400 dark:text-slate-500 ml-auto xl:hidden" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      
      <!-- Desktop: Icon first, then Text -->
      <svg 
        class="w-4 h-4 text-slate-400 dark:text-slate-500 mr-3 hidden xl:block" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <span class="text-sm text-slate-500 dark:text-slate-400 hidden xl:inline">
        {{ $t('CHAT_LIST.SEARCH.INPUT') }}
      </span>
    </button>
  </div>
  </template>

